import React from "react";
import {
  AllCapsAlerts,
  GET_SECURITY_ALERTS,
  OrderedAlerts,
  desiredOrderAlerts,
  sensitivityMap,
} from "./NetSpaceConstant";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import Page_Loader from "../../assets/vizr_images/page_loader.gif";
import { Grid, Box } from "material-ui-core";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { StyledCardHeader } from "./NetSpaceUtils";
import RadialChart from "./RadialChart";
import { sensitivityColor } from "./NetSpaceUtils";
import { CustomCard } from "./NetSpaceCommonComp";

function HostWithAlerts() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({
      type: GET_SECURITY_ALERTS,
    });
  }, []);
  const securityAlerts = useSelector(
    (state) => state.NetspaceReducer.securityAlerts
  );
  const loader = useSelector(
    (state) => state.NetspaceReducer.componentLoader[GET_SECURITY_ALERTS]
  );
  const totalAlerts = securityAlerts
    ? Object.values(securityAlerts).reduce((acc, curr) => acc + curr, 0)
    : 0;
  const renderContent = () => {
    if (securityAlerts) {
      let renderEachAlert = [];
      let radialData = [];
      desiredOrderAlerts.forEach((alert) => {
        if (alert in securityAlerts) {
          renderEachAlert.push(
            <>
              <Grid item xs={12}>
                <div className={alert}>
                  {securityAlerts[alert]} {sensitivityMap[alert]}
                </div>
              </Grid>
            </>
          );
          radialData.push({
            name: alert,
            value: securityAlerts[alert],
            fill: sensitivityColor(alert),
          });
        } else {
          renderEachAlert.push(
            <>
              <Grid item xs={12}>
                <div className={alert}>0 {sensitivityMap[alert]}</div>
              </Grid>
            </>
          );
          radialData.push({
            name: alert,
            value: 0,
            fill: sensitivityColor(alert),
          });
        }
      });
      radialData.push({ name: "", value: totalAlerts, fill: "#ffffff" });
      return (
        <a
          className="a-tag-none"
          href="https://nodezero.druvstar.net/investigate/hosts"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Grid container direction="row" spacing={2}>
            <div className="netspace-common-container-class">
              <div className="netspace-value-container">
                {renderEachAlert.map((item, i) => (
                  <React.Fragment key={i}>{item}</React.Fragment>
                ))}
              </div>
            </div>
            <Grid item xs={6}>
              <Box
                sx={{
                  width: 110,
                  height: 100,
                  marginLeft: 5,
                }}
              >
                <div className="radial-chart-container">
                  <RadialChart
                    radialData={radialData}
                    totalAlerts={totalAlerts}
                  />
                </div>
              </Box>
            </Grid>
          </Grid>
        </a>
      );
    }
  };
  return (
    <>
      <Grid item size={1}>
        <CustomCard color={"white"}>
          <StyledCardHeader title={`Total Alerts: ${totalAlerts}`} />
          <CardContent className="card-content">
            {loader ? (
              <img src={Page_Loader} alt="loading" className="loader-img"></img>
            ) : (
              renderContent()
            )}
          </CardContent>
        </CustomCard>
      </Grid>
    </>
  );
}

export default HostWithAlerts;
